"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import MyStreamWave from "../brain/my-stream/MyStreamWave";
import BrainContent from "../brain/content/BrainContent";
import { useAuth } from "../auth/Auth";
import useDeviceInfo from "../../hooks/useDeviceInfo";
import PrimaryButton from "../utils/button/PrimaryButton";
import useCreateModalState from "@/hooks/useCreateModalState";
import { useMyStreamOptional } from "@/contexts/wave/MyStreamContext";
import WaveScreenMessage from "./WaveScreenMessage";
const WavesView: React.FC = () => {
  const $ = _c(10);
  const myStream = useMyStreamOptional();
  const {
    connectedProfile
  } = useAuth();
  const {
    isApp
  } = useDeviceInfo();
  const {
    openWave
  } = useCreateModalState();
  const serialisedWaveId = myStream?.activeWave.id ?? null;
  const showPlaceholder = !serialisedWaveId && !isApp;
  let content = null;
  if (serialisedWaveId) {
    const t0 = `wave-${serialisedWaveId}`;
    let t1;
    if ($[0] !== serialisedWaveId || $[1] !== t0) {
      t1 = <MyStreamWave key={t0} waveId={serialisedWaveId} />;
      $[0] = serialisedWaveId;
      $[1] = t0;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    content = t1;
  } else {
    if (showPlaceholder) {
      let t0;
      if ($[3] !== connectedProfile || $[4] !== openWave) {
        t0 = connectedProfile ? <PrimaryButton onClicked={openWave} disabled={false} loading={false}><PlusIcon className="-tw-ml-1 tw-h-5 tw-w-5" />Create Wave</PrimaryButton> : null;
        $[3] = connectedProfile;
        $[4] = openWave;
        $[5] = t0;
      } else {
        t0 = $[5];
      }
      let t1;
      if ($[6] !== t0) {
        t1 = <WaveScreenMessage title="Select a Wave" description="Choose a wave to view its content and participate in the discussion." action={t0} />;
        $[6] = t0;
        $[7] = t1;
      } else {
        t1 = $[7];
      }
      content = t1;
    }
  }
  let t0;
  if ($[8] !== content) {
    t0 = <BrainContent activeDrop={null} onCancelReplyQuote={_temp}>{content}</BrainContent>;
    $[8] = content;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  return t0;
};
export default React.memo(WavesView);
function _temp() {}